module.exports = __webpack_public_path__ + "img/faq.3489b1e6.svg";